<script setup>
import { CALENDAR_PERIODS } from '../helpers/DatePickerHelper';

import NextButton from 'dashboard/components-next/button/Button.vue';

defineProps({
  calendarType: {
    type: String,
    default: 'start',
  },
  firstButtonLabel: {
    type: String,
    default: '',
  },
  buttonLabel: {
    type: String,
    default: '',
  },
  viewMode: {
    type: String,
    default: '',
  },
});
const emit = defineEmits(['prev', 'next', 'setView']);

const { YEAR } = CALENDAR_PERIODS;

const onClickPrev = type => {
  emit('prev', type);
};

const onClickNext = type => {
  emit('next', type);
};

const onClickSetView = (type, mode) => {
  emit('setView', type, mode);
};
</script>

<template>
  <div class="flex items-start justify-between w-full h-11 lg:h-9">
    <NextButton
      type="button"
      slate
      ghost
      xs
      icon="i-lucide-chevron-left"
      :aria-label="$t('DATE_PICKER.PREVIOUS_PERIOD')"
      class="rtl:rotate-180 min-h-11 min-w-11 lg:min-h-0 lg:min-w-0"
      @click.stop="onClickPrev(calendarType)"
    />
    <div class="flex items-center gap-1">
      <button
        v-if="firstButtonLabel"
        type="button"
        class="min-h-11 min-w-11 lg:min-h-0 lg:min-w-0 p-0 text-sm font-medium text-center text-n-slate-12 hover:text-n-brand"
        @click.stop="onClickSetView(calendarType, viewMode)"
      >
        {{ firstButtonLabel }}
      </button>
      <button
        v-if="buttonLabel"
        type="button"
        class="min-h-11 min-w-11 lg:min-h-0 lg:min-w-0 p-0 text-sm font-medium text-center text-n-slate-12"
        :class="{ 'hover:text-n-brand': viewMode }"
        @click.stop="onClickSetView(calendarType, YEAR)"
      >
        {{ buttonLabel }}
      </button>
    </div>
    <NextButton
      type="button"
      slate
      ghost
      xs
      icon="i-lucide-chevron-right"
      :aria-label="$t('DATE_PICKER.NEXT_PERIOD')"
      class="rtl:rotate-180 min-h-11 min-w-11 lg:min-h-0 lg:min-w-0"
      @click.stop="onClickNext(calendarType)"
    />
  </div>
</template>
